// extracted by mini-css-extract-plugin
export default {"list":"Trip_list__H21uc","addTrip":"Trip_addTrip__frPdT"};